import axios from 'axios'

const http = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API
})

const state = {
    categories: null
}

const getters = {
    getCategories: state => state.categories
}

const actions = {
    fetchCategory: ({commit}) => {
        http({
            method: "get",
            url: `/categories`
        }).then((res) => {
            commit('setCategory', res.data.results)
        })
    }
}

const mutations = {
    setCategory: (state, categories) => {
        state.categories = categories
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
